import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { ActivityProgress } from 'components/misc'
import { SectionCard } from 'components/sections/dashboard'
import { ACTIVITY_SECTIONS, ACTIVITY_STATES } from 'constants/enums'
import styles from './r-p-item-wrap.styl'

const click = {
  openDetail: [
    ACTIVITY_STATES.award_leader_singoff.id,
    ACTIVITY_STATES.waiting_for_approval.id,
    ACTIVITY_STATES.in_progress.id,
    ACTIVITY_STATES.assessment.id,
    ACTIVITY_STATES.complete.id,
    ACTIVITY_STATES.ceremony.id,
    ACTIVITY_STATES.office_signoff.id
  ],
  newActivity: [ACTIVITY_STATES.setup.id]
}

export default class RPItemWrap extends Component {
  static propTypes = {
    residentialProject: PropTypes.any,
    canSetupSections: PropTypes.bool,
    onShowReviseMessage: PropTypes.func.isRequired,
    notification: PropTypes.func.isRequired,
    onOpenDetail: PropTypes.func,
    onOpenNewRP: PropTypes.func,
    isBlocked: PropTypes.bool,
    notifyBlockedAward: PropTypes.func
  }

  handleClick = () => {
    const {
      residentialProject,
      canSetupSections,
      notification,
      onOpenDetail,
      onOpenNewRP,
      isBlocked,
      notifyBlockedAward
    } = this.props

    const rPState = get(residentialProject, 'state.value')

    if (isBlocked) {
      notifyBlockedAward()
    } else if (!canSetupSections) {
      notification(
        'Residential project cannot be created until your registration is approved',
        {
          intlKey:
            'notifications.residential_project_cannot_be_created_until_approved',
          status: 'info'
        }
      )
    } else if (click.newActivity.includes(rPState)) {
      onOpenNewRP(get(residentialProject, 'id'))
    } else if (click.openDetail.includes(rPState)) {
      onOpenDetail(get(residentialProject, 'id'))
    }
  }

  handleWarningClick = e => {
    e.stopPropagation()
    const { residentialProject } = this.props

    this.props.onShowReviseMessage(residentialProject)
  }

  render() {
    const { residentialProject } = this.props

    const rPState = get(residentialProject, 'state.value')
    const rPSection = ACTIVITY_SECTIONS.residential_project.id
    const returnedToParticipant = get(
      residentialProject,
      'returnedToParticipant'
    )

    const showProgress = [
      ACTIVITY_STATES.waiting_for_approval.id,
      ACTIVITY_STATES.award_leader_singoff.id,
      ACTIVITY_STATES.in_progress.id,
      ACTIVITY_STATES.assessment.id,
      ACTIVITY_STATES.complete.id,
      ACTIVITY_STATES.ceremony.id,
      ACTIVITY_STATES.office_signoff.id
    ].includes(rPState)

    return (
      <SectionCard
        onClick={this.handleClick}
        onWarningClick={this.handleWarningClick}
        activitySection={rPSection}
        title={
          ACTIVITY_STATES.setup.id === rPState ? (
            <FormattedMessage
              id="label.choose_project"
              defaultMessage="Choose project"
            />
          ) : (
            <FormattedMessage
              id="moduleTitle.residential_project"
              defaultMessage="Residential project"
            />
          )
        }
        caption={
          <FormattedMessage
            id="label.residential_project"
            defaultMessage="Residential project"
          />
        }
        activityState={rPState}
        activityProgress={
          <div className={styles.progressWrap}>
            <div className={styles.progressItem}>
              <ActivityProgress
                activitySection={rPSection}
                completedPercentage={
                  rPState === ACTIVITY_STATES.setup.id ? 0 : 100
                }
              />
            </div>
            <div className={`${styles.progressItem} ${styles.progressLast}`}>
              <ActivityProgress
                activitySection={rPSection}
                completedPercentage={
                  [
                    ACTIVITY_STATES.complete.id,
                    ACTIVITY_STATES.ceremony.id,
                    ACTIVITY_STATES.office_signoff.id
                  ].includes(rPState)
                    ? 100
                    : 0
                }
              />
            </div>
          </div>
        }
        sectionIcon={{
          add:
            [ACTIVITY_STATES.setup.id].includes(rPState) &&
            !returnedToParticipant,
          warning:
            [
              ACTIVITY_STATES.setup.id,
              // ACTIVITY_STATES.assessment.id,
              ACTIVITY_STATES.in_progress.id
            ].includes(rPState) && returnedToParticipant,
          checked: [
            ACTIVITY_STATES.complete.id,
            ACTIVITY_STATES.ceremony.id,
            ACTIVITY_STATES.office_signoff.id
          ].includes(rPState)
        }}
        showProgress={showProgress}
      />
    )
  }
}
